import { useTranslations } from '@vocab/react';
import { Bleed, ButtonIcon, IconClear, Box } from 'braid-design-system';
import type { ComponentProps, FC } from 'react';

import { ResponsiveText } from '../ResponsiveText';

import translations from './.vocab';
import { FilterFacetBadge } from './FilterFacetBadge';

type BoxProps = ComponentProps<typeof Box>;

type FilterFacetTag = Pick<
  BoxProps,
  'component' | 'aria-label' | 'onClick' | 'onKeyDown' | 'tabIndex'
> & {
  innerRef?: BoxProps['ref'];
  label: string;
  count?: number;
  onClear?: () => void;
};

export const FilterFacetTag: FC<FilterFacetTag> = ({
  label,
  count,
  onClear,
  innerRef,
  ...boxProps
}) => {
  const { t } = useTranslations(translations);
  return (
    <Box
      display="flex"
      flexWrap="nowrap"
      overflow="hidden"
      position="relative"
      alignItems="center"
      justifyContent="center"
      paddingY="xxsmall"
      paddingX="xsmall"
      background="neutralLight"
      borderRadius="full"
      gap="xsmall"
      ref={innerRef}
      {...boxProps}
    >
      <ResponsiveText
        maxLines={1}
        size={{
          mobile: 'standard',
          tablet: 'small',
        }}
        fallbackSize="small"
      >
        {label}
      </ResponsiveText>

      {count !== undefined ? (
        <Bleed vertical="xxsmall">
          <FilterFacetBadge count={count} isHighlighted />
        </Bleed>
      ) : null}

      {onClear ? (
        <ButtonIcon
          id={`remove-${label}-btn`}
          size="small"
          icon={<IconClear />}
          label={t('Clear {item}', { item: label })}
          onClick={() => onClear()}
          variant="transparent"
        />
      ) : null}
    </Box>
  );
};
